/*=============================================== IconPage ===============================================*/

import styled from "styled-components/macro"
import { Icon, Text } from "tsx-library-julseb"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

import { commonProps } from "data"

const IconMixin = styled(Text)`
    display: flex;
    align-items: center;

    &:before {
        ${({ theme }) =>
            theme.Icon({
                $name: "chevron-left",
                $color: "secondary-400",
                $size: 48,
            })};
    }
`

const IconPage = () => {
    const items: ItemType[] = [
        {
            title: "Icon",
            content: <Icon src="check" color="success" size={64} />,
            code: '<Icon src="check" color="success" size={64} />',
        },
        {
            title: "Styled component mixin",
            content: <IconMixin>Text with icon mixin</IconMixin>,
            // eslint-disable-next-line
            code: 'const IconMixin = styled(Text)`\n    display: flex;\n    align-items: center;\n\n    &:before {\n        ${({ theme }) =>\n            theme.Icon({\n                $name: "chevron-left",\n                $color: "secondary-400",\n                $size: 48,\n            })};\n    }\n`\n\n<IconMixin>Text with icon mixin</IconMixin>',
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            subtitle: "src",
            type: "string",
            required: true,
        },
        {
            subtitle: "size",
            type: "number",
            default: 24,
        },
        {
            subtitle: "color",
            type: "string",
            possibleString: commonProps.allColors,
            default: "currentColor",
        },
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default IconPage
